import { Theme } from '@mui/material';

const useStyles = (theme: Theme, coverUrl?: string, isGray?: boolean) => ({
  highlight: {
    position: 'absolute',
    width: '100%',
    height: '95dvh',
    top: 0,
    left: 0,
    inset: 0,
    zIndex: 0,
    pointerEvents: 'none',
    backgroundImage: `
    linear-gradient(
      to bottom,
      rgba(20, 20, 20, 0) 80%,
      rgba(20, 20, 20, 1) 100%
    ),
    url('${coverUrl?.replace('900', '1790')?.replace('500', '975')}')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    filter: isGray ? 'grayscale(60%)' : 'none',
  },
});

export default useStyles;
